export const dealer = {
  "dealer.getBase": "dealer.getBase",
  "dealer.updateBase.photo": "dealer.updateBase.photo",
  "dealer.updateBase": "dealer.updateBase",
  "dealer.create": "dealer.create",
  "dealer.getAddress": "dealer.getAddress",
  "dealer.updateAddress": "dealer.updateAddress",
  "dealer.getOwners": "dealer.getOwners",
  "dealer.updateOwners": "dealer.updateOwners",
  "dealer.deleteOwner": "dealer.deleteOwner",
  "dealer.getGuide": "dealer.getGuide",
  "dealer.updateGuide": "dealer.updateGuide",
  "dealer.getEmployee": "dealer.getEmployee",
  "dealer.getDocs": "dealer.getDocs",
  "dealer.updateDocs": "dealer.updateDocs",
  "dealer.getEpd": "dealer.getEpd",
  "dealer.updateEpd": "dealer.updateEpd",
  "dealer.deleteEpd": "dealer.deleteEpd",
  "dealer.generateRequsites": "dealer.generateRequsites",
  "dealer.dmsImport": "dealer.dmsImport",
  "dealer.updateAddress.lada.sale": "dealer.updateAddress.lada.sale",
  "dealer.updateAddress.lada.sto": "dealer.updateAddress.lada.sto",
  "dealer.getDealerPhotos": "dealer.getDealerPhotos",
  "dealer.registryReport": "dealer.registryReport",
  "dealer.candidate": "dealer.candidate",
  "dealer.getDnmRoleMappings": "dealer.getDnmRoleMappings",
  "dealer.updateDnmRoleMappings": "dealer.updateDnmRoleMappings",
  "dealer.deleteDnmRoleMappings": "dealer.deleteDnmRoleMappings",
} as const;
